import CP from "./CP";

export default {
  CP
}